import script from "./bcc_submitters_autocomplete_v2.vue?vue&type=script&setup=true&lang=js"
export * from "./bcc_submitters_autocomplete_v2.vue?vue&type=script&setup=true&lang=js"

import "./bcc_submitters_autocomplete_v2.vue?vue&type=style&index=0&id=7b674930&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b674930"]])

export default __exports__